import {fetchRemote, fetchRemoteResult} from "./api-util";

const apiEndpoint = '/api/Division/';
const controllerEndpoint = '/Area/';

/**
 * @typedef DivisionTree
 * 
 * @property {String} id
 * @property {String} name
 * @property {Boolean} isEnabled
 * @property {DivisionTree[]} childDivisions Collection containing all direct children.
 */

const urlSerialize = function(obj){
    return Object.keys(obj)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`)
        .join('&');
};

export default {
    /**
     * Fetch the list of accessible divisions
     * 
     * @param {Object} opts
     * @param {Number} [opts.take=9999] Amount of divisions to take
     * @param {Boolean} [opts.includeDisabled=false] Indicates whether or not disabled divisions should be included
     * @returns {Promise | Promise<DivisionTree>}
     */
    getDivisionsList(opts){
        opts = opts || {};
        
        const params = {
            take: opts.take || 9999,
            includeDisabled: opts.includeDisabled === true
        };

        const serializedParams = urlSerialize(params);
        const endpoint = `${controllerEndpoint}List?${serializedParams}`;
        
        return fetchRemoteResult(endpoint);
    },
    
    getAllDivisions(){
        //Tad hackey-should suffice for the time being
        const params = {
            'firstRequest': true,
            'maxResults': 9999
        };

        const serializedParams = urlSerialize(params);

        const endpoint = `${apiEndpoint}?${serializedParams}`;
        
        return new Promise((resolve, reject) => {
            fetchRemote(endpoint).then(
                response => {
                    response.json().then(
                        data => {
                            //Map to uniform format
                            //Drop extra properties
                            data = data.Data;
                                // .filter(d => !d.IsEnabled)
                                // .map(division => ({
                                //     id: division.Id,
                                //     name: division.Name,
                                //     description: division.Description,
                                //     parentId: division.ParentId,
                                //     type: division.Type,
                                //     modified: division.Modified,
                                //     isEnabled: division.IsEnabled
                                // }));
                            
                            resolve(data);
                        },
                        error => reject(error)
                    );
                },
                error => reject(error));
        });
    },
    getEnabledDivisions(){
        const obj = this;
        
        return new Promise((resolve, reject) => {
            obj.getAllDivisions()
                .then((divisions) => {
                    //Take all enabled divisions
                    resolve(divisions.filter(d => d.IsEnabled));
                }, reject);
        });
    }
};
